import script from "./ChangePassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&setup=true&lang=ts"

import "./ChangePassword.vue?vue&type=style&index=0&id=64bc392c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64bc392c"]])

export default __exports__